import {apiUrl} from '../common/Globals';
import {stringify} from 'query-string';
import {GET_LIST, GET_ONE, CREATE, UPDATE} from 'react-admin';
import {fileUploadBase64Payload} from '../common/Utils';
import {HTTP_GET, HTTP_POST} from '../common/HttpService';

const resourceBaseUlr = apiUrl + '/tool';

const getTool = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/id/${id}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const getTools = async (params) => {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;

  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify(params.filter)
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};
const ToolCreate = async (params) => {
  const url = `${resourceBaseUlr}`;
  let ImgUrl = '';
  if (params.data.images && params.data.images.title) {
    const imageUploadParams = {};
    const imagesss = await fileUploadBase64Payload([params.data.images], 'image');
    imageUploadParams.data = {};
    imageUploadParams.data.payloads = imagesss;
    imageUploadParams.data.resource = 'tool';
    imageUploadParams.data.resourceName = params.data.equipmentType ? params.data.equipmentType : '';
    imageUploadParams.data.id = 1;
    const url = apiUrl + '/localupload';
    const body = imageUploadParams.data;
    let res = await HTTP_POST(url, body);
    if (res.success && res.data) {
      ImgUrl = res.data;
    }
  }
  params.data.toolImagePath = ImgUrl;
  params.data.vendorId = 'ven' + params.data.Vendors;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};
const ToolUpdate = async (params) => {
  // const {id} = params;
  const url = `${resourceBaseUlr}/update/${params['id']}`;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};
const ToolsDataProvider = (type, resource, params) => {
  switch (type) {
    case GET_LIST:
      return getTools(params);

    case GET_ONE:
      return getTool(params);
    case CREATE:
      return ToolCreate(params);
    case UPDATE:
      return ToolUpdate(params);
    default:
      return Promise.reject('Unknown Type');
  }
};

export default ToolsDataProvider;
